"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeclinationInterpolationArray = exports.getRightAscensionInterpolationArray = exports.getLatitudeInterpolationArray = exports.getLongitudeInterpolationArray = exports.getInterpolateValue5 = exports.tabularInterpolation5 = exports.tabularInterpolation3 = void 0;
var time_1 = require("../time");
function tabularInterpolation3(values, n) {
    if (n === void 0) { n = 0.0; }
    var y2 = values[1];
    var A = values[1] - values[0];
    var B = values[2] - values[1];
    var C = B - A;
    return y2 + 0.5 * n * (A + B + n * C);
}
exports.tabularInterpolation3 = tabularInterpolation3;
function tabularInterpolation5(values, n) {
    if (n === void 0) { n = 0.0; }
    var y3 = values[2];
    var A = values[1] - values[0];
    var B = values[2] - values[1];
    var C = values[3] - values[2];
    var D = values[4] - values[3];
    var E = B - A;
    var F = C - B;
    var G = D - C;
    var H = F - E;
    var J = G - F;
    var K = J - H;
    while (true) {
        var numerator = -24 * y3 + Math.pow(n, 2) * (K - 12 * F) - 2 * Math.pow(n, 3) * (H + J) - Math.pow(n, 4) * K;
        var denominator = 2 * (6 * B + 6 * C - H - J);
        var nNew = numerator / denominator;
        if (nNew === n) {
            return n;
        }
        n = nNew;
    }
}
exports.tabularInterpolation5 = tabularInterpolation5;
function getInterpolateValue5(values, n) {
    if (n === void 0) { n = 0.0; }
    var y3 = values[2];
    var A = values[1] - values[0];
    var B = values[2] - values[1];
    var C = values[3] - values[2];
    var D = values[4] - values[3];
    var E = B - A;
    var F = C - B;
    var G = D - C;
    var H = F - E;
    var J = G - F;
    var K = J - H;
    return y3 + n / 2 * (B + C)
        + Math.pow(n, 2) / 2 * F
        + n * (Math.pow(n, 2) - 1) / 12 * (H + J)
        + Math.pow(n, 2) * (Math.pow(n, 2) - 1) / 24 * K;
}
exports.getInterpolateValue5 = getInterpolateValue5;
function getLongitudeInterpolationArray(ObjConstructor, jd0, nMax) {
    if (nMax === void 0) { nMax = 1.0; }
    return __awaiter(this, void 0, void 0, function () {
        var result, n, jd, toi, object, lon;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = [];
                    n = -1 * nMax;
                    _a.label = 1;
                case 1:
                    if (!(n <= nMax)) return [3, 4];
                    jd = jd0 + n;
                    toi = time_1.createTimeOfInterest.fromJulianDay(jd);
                    object = new ObjConstructor(toi);
                    return [4, object.getApparentGeocentricEclipticSphericalCoordinates()];
                case 2:
                    lon = (_a.sent()).lon;
                    result.push(lon);
                    _a.label = 3;
                case 3:
                    n++;
                    return [3, 1];
                case 4: return [2, _fix360Crossing(result)];
            }
        });
    });
}
exports.getLongitudeInterpolationArray = getLongitudeInterpolationArray;
function getLatitudeInterpolationArray(ObjConstructor, jd0, nMax) {
    if (nMax === void 0) { nMax = 1.0; }
    return __awaiter(this, void 0, void 0, function () {
        var result, n, jd, toi, object, lat;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = [];
                    n = -1 * nMax;
                    _a.label = 1;
                case 1:
                    if (!(n <= nMax)) return [3, 4];
                    jd = jd0 + n;
                    toi = time_1.createTimeOfInterest.fromJulianDay(jd);
                    object = new ObjConstructor(toi);
                    return [4, object.getApparentGeocentricEclipticSphericalCoordinates()];
                case 2:
                    lat = (_a.sent()).lat;
                    result.push(lat);
                    _a.label = 3;
                case 3:
                    n++;
                    return [3, 1];
                case 4: return [2, result];
            }
        });
    });
}
exports.getLatitudeInterpolationArray = getLatitudeInterpolationArray;
function getRightAscensionInterpolationArray(ObjConstructor, jd0, nMax) {
    if (nMax === void 0) { nMax = 1.0; }
    return __awaiter(this, void 0, void 0, function () {
        var result, n, jd, toi, object, rightAscension;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = [];
                    n = -1 * nMax;
                    _a.label = 1;
                case 1:
                    if (!(n <= nMax)) return [3, 4];
                    jd = jd0 + n;
                    toi = time_1.createTimeOfInterest.fromJulianDay(jd);
                    object = new ObjConstructor(toi);
                    return [4, object.getApparentGeocentricEquatorialSphericalCoordinates()];
                case 2:
                    rightAscension = (_a.sent()).rightAscension;
                    result.push(rightAscension);
                    _a.label = 3;
                case 3:
                    n++;
                    return [3, 1];
                case 4: return [2, _fix360Crossing(result)];
            }
        });
    });
}
exports.getRightAscensionInterpolationArray = getRightAscensionInterpolationArray;
function getDeclinationInterpolationArray(ObjConstructor, jd0, nMax) {
    if (nMax === void 0) { nMax = 1.0; }
    return __awaiter(this, void 0, void 0, function () {
        var result, n, jd, toi, object, declination;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    result = [];
                    n = -1 * nMax;
                    _a.label = 1;
                case 1:
                    if (!(n <= nMax)) return [3, 4];
                    jd = jd0 + n;
                    toi = time_1.createTimeOfInterest.fromJulianDay(jd);
                    object = new ObjConstructor(toi);
                    return [4, object.getApparentGeocentricEquatorialSphericalCoordinates()];
                case 2:
                    declination = (_a.sent()).declination;
                    result.push(declination);
                    _a.label = 3;
                case 3:
                    n++;
                    return [3, 1];
                case 4: return [2, result];
            }
        });
    });
}
exports.getDeclinationInterpolationArray = getDeclinationInterpolationArray;
function _fix360Crossing(raArray) {
    var result = [];
    var add = 0;
    var previousValue = 0;
    for (var i = 0; i < raArray.length; i++) {
        var currentValue = raArray[i];
        if (i > 0 && previousValue - currentValue > 270) {
            add += 360;
        }
        if (i > 0 && currentValue - previousValue > 270) {
            add -= 360;
        }
        result.push(currentValue + add);
        previousValue = currentValue;
    }
    if (add < 0) {
        return result.map(function (entry) { return entry + 360; });
    }
    return result;
}
